(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.languageSelector = {
        attach: function (context, settings) {
            const STORAGE_KEY = 'language_selector_dismissed';

            once('language-selector', '.language-selector', context).forEach(function (selector) {
                if (localStorage.getItem(STORAGE_KEY) === 'true') {
                    return;
                }

                setTimeout(function () {
                    selector.classList.add('language-selector--visible');
                }, 1500);

                const buttons = selector.querySelectorAll('.language-selector__buttons a');

                buttons.forEach(function (button) {
                    button.addEventListener('click', function () {
                        const href = button.getAttribute('href') || '';
                        const langMatch = href.match(/\/(en|fr)[-a-z]*\//);
                        const selectedLang = langMatch ? langMatch[1] : 'en';
                        localStorage.setItem(STORAGE_KEY, 'true');
                        selector.classList.remove('language-selector--visible');
                        const event = new CustomEvent('languageSelected', {
                            detail: { language: selectedLang }
                        });
                        document.dispatchEvent(event);
                    });
                });
            });
        }
    };

})(Drupal, once);
